import {type CreatePaymentMethodEpsData} from '@stripe/stripe-js';
import {type IStripeContext, type StripeGateway} from '../../../models/stripe';
import {PeachPayCustomer} from '../../../reducers/peachPayCustomerReducer';
import {getLocaleText} from '../../../util/translation';
import epsBadgeURL from '../../../../img/badge/eps.svg';
import epsImageURL from '../../../../img/marks/eps.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';

function initStripeEPSMethod(): StripeGateway {
	return {
		config: {
			name: Feature.metadata<string>(FeatureFlag.STRIPE_EPS_GATEWAY, 'title') ?? 'EPS',
			gatewayId: 'peachpay_stripe_eps',
			description: getLocaleText('After selecting <b>Pay</b> you will be redirected to complete your payment.'),
			assets: {
				title: {src: epsImageURL},
				badge: {src: epsBadgeURL},
			},
		},
		async tokenize(context) {
			const {stripe} = context;

			const {paymentMethod, error} = await stripe.createPaymentMethod({
				type: 'eps',
				billing_details: PeachPayCustomer.stripeBillingDetails(),
			} as CreatePaymentMethodEpsData);

			if (error) {
				const message = error.message ?? 'Failed to tokenize payment method.';

				return [null, {
					paymentStatus: 'creationfailed',
					note: message,
				}];
			}

			if (!paymentMethod?.id) {
				return [null, {
					paymentStatus: 'creationfailed',
					note: 'Failed to tokenize payment method.',
				}];
			}

			return [paymentMethod.id, {}];
		},
		async confirm(context: IStripeContext, clientSecret: string, intermediateURL: string) {
			const {stripe} = context;

			const {paymentIntent, error} = await stripe.confirmEpsPayment(clientSecret, {return_url: intermediateURL});

			if (error) {
				const message = error.message ?? 'Failed to confirm payment.';
				return [null, {
					note: message,
				}];
			}

			if (paymentIntent) {
				return ['success', {}];
			}

			return [null, {}];
		},
	};
}

export {initStripeEPSMethod};
